<template>
  <TheCameraBanner>
    <div class="videoBanner__textContainer">
      <h2
        class="videoBanner__title"
        :style="`background-image: url(${titleImage});`"
      >
        {{ title }}
      </h2>

      <div class="videoBanner__buttonContainer">
        <router-link
          v-for="(button, index) in buttonLists"
          :key="index"
          class="videoBanner__button clickable"
          :style="`background-image: url(${button.image});`"
          :title="`點擊前往影音專區-${button.text}`"
          :to="{ name: button.routeName }"
        >
          {{ button.text }}
        </router-link>
      </div>
    </div>
  </TheCameraBanner>
</template>

<script>
import TheCameraBanner from '@/components/TheCameraBanner.vue'

export default {
  components: {
    TheCameraBanner
  },
  data() {
    return {
      titleImageTable: {
        VideoActivity: require('@/assets/image/Video/VideoTitleActivity.png'),
        VideoNavigation: require('@/assets/image/Video/VideoTitleNavigation.png'),
        VideoMine: require('@/assets/image/Video/VideoTitleMine.png')
      },
      titleTable: {
        VideoActivity: '活動記事',
        VideoNavigation: '導覽影片',
        VideoMine: '礦山故事'
      }
    }
  },
  computed: {
    title() {
      const routeName = this.$route.name
      const title = this.titleTable[routeName]
      if (!title) return ''
      return title
    },
    titleImage() {
      const routeName = this.$route.name
      const titleImage = this.titleImageTable[routeName]
      if (!titleImage) return ''
      return titleImage
    },
    buttonLists() {
      // elementary
      // junior
      // mine
      const routeName = this.$route.name
      const activity = {
        text: '活動記事',
        image: require('@/assets/image/Video/VideoButtonActivity.png'),
        routeName: 'VideoActivity'
      }
      const navigation = {
        text: '導覽影片',
        image: require('@/assets/image/Video/VideoButtonNavigation.png'),
        routeName: 'VideoNavigation'
      }
      const mine = {
        text: '礦山故事',
        image: require('@/assets/image/Video/VideoButtonMine.png'),
        routeName: 'VideoMine'
      }

      if (routeName === 'VideoActivity') {
        return [navigation, mine]
      }

      if (routeName === 'VideoNavigation') {
        return [activity, mine]
      }

      if (routeName === 'VideoMine') {
        return [navigation, activity]
      }
      return []
    }
  },
  watch: {
    $route(to, from) {
      this.setShowSelect()
    }
  },
  mounted() {
    this.setShowSelect()
  },
  methods: {
    setShowSelect() {
      const routeName = this.$route.name
      this.showSelect = routeName !== 'ELearningMine'
    }
  }
}
</script>

<style lang="scss">
.videoBanner {
  &__textContainer {
    width: 1280px;
    max-width: 95%;
    margin: 0 auto;
    padding-left: 25rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__selectContainer {
    width: 18rem;
    flex-shrink: 0;
  }

  &__title {
    flex-shrink: 0;
    width: 14.55rem;
    height: 4.55rem;
    text-indent: 101%;
    white-space: nowrap;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__desc {
    font-size: 2rem;
    line-height: 3.1rem;
    text-align: justify;
  }

  &__buttonContainer {
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
  }

  &__button {
    width: 15.5rem;
    height: 5.5rem;
    text-indent: 101%;
    white-space: nowrap;
    overflow: hidden;
    padding: 0;
    background-color: transparent;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    border: none;
    margin: 0.5rem 1rem;
  }
}

@media (max-width: 768px) {
  .videoBanner {
    &__title {
      margin: 0 auto;
      margin-bottom: 2.05rem;
    }

    &__textContainer {
      width: 100%;
      flex-direction: column;
      align-content: center;
      padding: 0;
    }

    &__buttonContainer {
      margin: 0;
      margin-top: 3.2rem;
      flex-wrap: nowrap;
    }
  }
}
</style>
